import { Component, Input } from '@angular/core';
import { PaginationComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-custom-pagination',
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
  standalone: false,
})
export class CustomPaginationComponent extends PaginationComponent {
  @Input() override pageRoute: string = './';
}
